export default {
  actionToExecute: 'Acción a ejecutar',
  addAction: 'Añade la acción',
  addListToSequence: 'Añadir la lista a la secuencia',
  addPerson: 'Añadir persona',
  addPersonOrStep: 'Añadir persona o paso',
  addScheduleName: 'Agregar nombre del horario',
  addScheduleObservations: 'Añade observaciones del horario',
  addStep: 'Agrega el paso',
  addTask: 'Agregar tarea',
  addTrigger: 'Añade el disparador',
  addUserToSequence: 'Añadir el usuario a la secuencia',
  automaticEmail: 'Correo electrónico automático',
  changeUserFromSequence: 'Cambiar el usuario de la secuencia',
  companyName: 'Nombre de la compañia',
  completion: 'Finalización',
  continueWithoutSaving: 'Continuar sin guardar',
  copyCustomizedField: 'Copiar campo personalizado',
  couldNotCopyFieldToClipboard: 'No se pudo copiar el campo al portapapeles',
  createAValidTask: 'Crear una tarea válida',
  createRule: 'Crear regla',
  createSequence: 'Crear secuencia',
  customFieldSuccessfullyCopiedToClipboard: 'El campo personalizado fue copiado con éxito al portapapeles',
  customizeDay: 'Personalizar día',
  customizeScheduleDays: 'Personalizar los días del horario',
  dayDisabled: 'Día desabilitado',
  days: 'Días',
  deleteAction: 'Eliminar la acción',
  deleteList: 'Borrar lista',
  deleteSequence: 'Borrar secuencia',
  deleteTrigger: 'Borrar el disparador',
  deleteUserFromSequence: 'Eliminar el usuario de la secuencia',
  deleteUserFromSequenceConfirmation: '¿Realmente quieres borrar a este usuario de la secuencia?',
  doNothing: 'No hacer nada',
  doYouReallyWanToDeleteThisSequence: '¿Realmente quieres borrar esta secuencia?',
  editList: 'Editar lista',
  editPerson: 'Editar persona',
  editRule: 'Editar regla',
  editSchedule: 'Editar el horario',
  emailHooksInformation: 'Información de los hooks del correo electrónico',
  emailStatistics: 'Estadísticas de correo electrónico',
  enterRuleDescription: 'Introduzca la descripción de la regla',
  editSequence: 'Editar sequencia',
  editStep: 'Editar paso',
  enterRuleName: 'Introduzca el nombre de la regla',
  enterStepName: 'Introduzca el nombre del paso',
  enterStepOrder: 'Introducir el orden de los pasos',
  enterStepTips: 'Ingresar consejos de pasos',
  enterTaskName: 'Introduzca el nombre de la tarea',
  enterTriggerName: 'Introduzca el nombre del disparador',
  executeAnotherActionInAGivenTime: 'Ejecutar otra acción en un tiempo determinado',
  exitWhen: 'Salir cuando',
  goBackToTheSequence: 'Vuelve a la secuencia',
  hours: 'Horas',
  ifNotSequenceStepPickedNote: 'Nota: Si no eliges un paso, el siguiente paso de la secuencia será elegido por defecto',
  insertEmailSubject: 'Inserte el asunto del correo electrónico',
  isActive: 'Está activo',
  isDayActive: 'Está el día activo?',
  isGlobal: 'Es global?',
  isSequenceActive: 'Es una secuencia activa?',
  isStepActive: 'Activar paso?',
  lastEditionDate: 'Fecha de la última edición',
  listNotFound: 'Lista no encontrada',
  listSuccessfullyAddedToSequence: 'Lista añadida con éxito a la secuencia',
  listView: 'Vista de lista',
  loadingInformation: 'Cargando información',
  loadingRule: 'Cargando regla',
  loadingSchedule: 'Cargando horario',
  loadingSequence: 'Cargando sequencia',
  loadingSequenceStatistics: 'Cargando las estadísticas de la secuencia',
  loadingStep: 'Cargando paso',
  manualEmail: 'Correo electrónico manual',
  nestedActionToExecute: 'Acción anidada a ejecutar',
  newRule: 'Nueva regla',
  newSchedule: 'Nuevo horario',
  newSequence: 'Nueva secuencia',
  noRulesCreated: 'No se han creado reglas',
  noSchedulesCreated: 'No se han creado horarios',
  noSequencesCreated: 'No se han creado secuencias',
  order: 'Pedido',
  owner: 'Propietario',
  pauseSequence: 'Pausar secuencia',
  peopleInTheSequence: 'Personas en la secuencia',
  peoplePerStep: 'Personas por paso',
  peopleThatLeftTheSequence: 'Personas que dejaron la secuencia',
  personSuccessfullyAddedToSequence: 'Persona añadida con éxito a la secuencia',
  personSuccessfullyChangedFromSequence: 'La persona cambió con éxito de secuencia',
  personSuccessfullyCreated: 'Persona creada con éxito',
  personSuccessfullyUpdated: 'Persona se actualizó con éxito',
  pickAnAction: 'Elige una acción',
  pickAnHour: 'Elige una hora',
  pickADate: 'Elige una fecha',
  pickARule: 'Elige una regla',
  pickASchedule: 'Elige un horario',
  pickAScheduleForTheSequence: 'Elige un horario para la secuencia',
  pickAStep: 'Elige un paso',
  pickFinishingTime: 'Escoge el momento de finalización',
  pickHour: 'Elige la hora',
  pickMinutes: 'Elige los minutos',
  pickTimeZone: 'Escoge la zona horaria',
  pickStartingDateTimeAndTimeZone: 'Elige la fecha de inicio, la hora y la zona horaria',
  pickStartingTime: 'Elige la hora de inicio',
  pickTheSequenceToChangeTo: 'Elige la secuencia para cambiar a',
  pickTheStepToChangeTo: 'Elige el paso para cambiar a',
  pickTriggerType: 'Escoge el tipo de disparador',
  prepareEmail: 'Prepara el correo electrónico',
  project: 'Proyecto',
  relateRuleToSequence: 'Relacionar la regla con una secuencia',
  relateRuleToSequenceOrSetAsGlobal: 'Relacionar la regla con una secuencia o seleccionar como global',
  removeUserFromSequence: 'Eliminar el usuario de la secuencia',
  ruleDetails: 'Detalles de la regla',
  ruleNotFound: 'Regla no encontrada',
  ruleSuccessfullyCreated: 'Regla creada con éxito',
  ruleSuccessfullyUpdated: 'Regla actualizada con éxito',
  rules: 'Reglas',
  runSequence: 'Secuencia de ejecución',
  saveTemplate: 'Guarda la plantilla',
  saveTemplateWarning: 'No has guardado o actualizado esta plantilla, ¿estás seguro de continuar sin guardarla o actualizarla?',
  scheduleDays: 'Días del horario',
  scheduleName: 'Nombre del horario',
  scheduleObservations: 'Observaciones del horario',
  scheduleSuccessfullyCreated: 'Horario creado con éxito',
  scheduleSuccessfullyUpdated: 'Horario actualizado con éxito',
  schedules: 'Horarios',
  seeList: 'Ver lista',
  seePerson: 'Ver persona',
  seeSequence: 'Ver secuencia',
  selectARule: 'Seleccione una regla',
  selectASequence: 'Seleccione una secuencia',
  sequence: 'Secuencia',
  sequenceCompany: 'Compañía de la secuencia',
  sequenceDetails: 'Detalles de la secuencia',
  sequenceInformationWillBeLostAfterDeletionOfTheSequence: 'Todas las reglas, pasos y cualquier información relacionada con la secuencia ya no estarán disponibles',
  sequenceLeads: 'Personas de la secuencia',
  sequenceName: 'Nombre de la secuencia',
  sequenceOwner: 'Propietario de la secuencia',
  sequencePeople: 'Personas de la secuencia',
  sequenceRuleType: 'Tipo de regla',
  sequenceSchedule: 'Horario de la secuencia',
  sequenceStatistics: 'Estadísticas de la secuencia',
  sequenceStatisticsNotFound: 'Estadísticas de la secuencia no encontradas',
  sequenceStatus: 'Estado de la secuencia',
  sequenceStatusSuccessfullyChanged: 'El estado de la secuencia se ha cambiado con éxito',
  sequenceSteps: 'Pasos de la secuencia',
  sequenceSuccessfullyCreated: 'Secuencia creada con éxito',
  sequenceSuccessfullyDeleted: 'Secuencia borrada con éxito',
  sequenceSuccessfullyUpdated: 'Secuencia actualizada con éxito',
  sequences: 'Secuencias',
  sequencesRules: 'Reglas de las secuencias',
  sequencesList: 'Lista de secuencias',
  setRuleAsGlobal: 'Establecer la regla como global',
  sms: 'Sms',
  smsHooksInformation: 'La información de los hooks del Sms',
  smsStatistics: 'Estadísticas de Sms',
  social: 'Social',
  settings: 'Ajustes',
  statistics: 'Estadísticas',
  step: 'Paso',
  stepSuccessfullyCreated: 'Paso creado con éxito',
  stepSuccessfullyUpdated: 'Paso actualizado con éxito',
  stepTips: 'Consejos de paso',
  stepType: 'Tipo de paso',
  task: 'Tarea',
  taskHooksInformation: 'La información de los hooks de la tarea',
  taskStatistics: 'Estadísticas de la tarea',
  templateSuccessfullySaved: 'Plantilla guardada con éxito',
  templateSuccessfullyUpdated: 'La plantilla se actualizó con éxito',
  theSequenceIsRunningNow: 'La secuencia se está ejecutando ahora',
  timeToFinishTheTaskAfterRuleGetsExecuted: 'Tiempo para terminar la tarea después de que la regla sea ejecutada.',
  timeToWaitBeforeRunningThisStep: 'Tiempo de espera antes de ejecutar este paso',
  timeToWaitBeforeNestedActionGetsExecuted: 'Tiempo de espera antes de que la acción anidada se ejecute',
  tipsForTheStep: 'Consejos para el paso tipo {type}',
  triggerName: 'Nombre del disparador',
  triggerActions: 'Acciones del disparador',
  updateTemplateWarning: 'La plantilla {templateName} va a ser actualizada, ¿estás seguro de esto?',
  userNotFound: 'Usuario no encontrado',
  userSuccessfullyDeletedFromSequence: 'Usuario eliminado con éxito de la secuencia',
  waitFor: 'Espere por',
  withoutTips: 'Sin consejos...',
  writeEmail: 'Escriba el correo electrónico',
  writeSms: 'Escriba el SMS',
  youMustFillAllFieldsCorrectly: 'Debes rellenar todos los campos correctamente',
  youMustPickADate: 'Debes elegir una fecha',
  pickAnOutcome: 'Selecciona un resultado',
  pickAnOutcomeForTheTask: 'Selecciona un resultado para la tarea',
  deliveredPlural: 'Entregado | Entregados',
  clickedPlural: 'Clickeado | Clickeados',
  deferral: 'Aplazado | Aplazados',
  hardBounced: 'Rebote fuerte | Rebotes Fuertes',
  softBounced: 'Rebote suave | Rebotes suaves',
  spamBlocked: 'Bloqueado por spam | Bloqueados por spam',
  unsubscribed: 'Desuscrito | Desuscritos',
  blackList: 'Lista negra',
  whiteList: 'Lista blanca',
  unknown: 'Desconocido | Desconocidos',
  pending: 'Pendiente | Pendientes',
  scheduled: 'Porgramado | Programados',
  queued: 'Encolado | Encolados'
}
